{
  "404": {
    "text": {
      "1": "This page does not exist.",
      "2": "Tap/click on a screen to continue",
      "3": "Redirecting..."
    }
  },
  "about-me": {
    "title": "About me",
    "list": [
      { "title": "{{totalExperience}} of experience in software development" },
      { "title": "Experience in managing team." },
      { "title": "Leading features and projects." },
      { "title": "Designing software architecture." },
      { "title": "Planning features implementation and delivery them in time." },
      { "title": "Conducting technical and manager interviews." },
      { "title": "Experience in working with multiple teams and departments to integrate all development pieces together." },
      { "title": "Experience in mentoring and teaching junior peers." },
      { "title": "Solid knowledge and experience in backend, frontend, infrastructure, CI/CD development." },
      { "title": "Strong experience in Java, TypeScript, Go, Python, GitHub Actions, DevSecOps, Application Security." },
      { "title": "Writing customer facing as well as internal documentation." },
      { "title": "Publishing technical articles." },
      {
        "title": "Participating in open source community:",
        "list": [
          { "title": "Creating pull requests and opening tickets to open source projects" },
          { "title": "Developed and released 35+ GitHub Actions to the marketplace" },
          { "title": "Actively participating in StackOverflow and LeetCode discussions" }
        ]
      }
    ]
  },
  "author": {
    "full-name": "Yevhen Fabizhevskyi",
    "given-name": "Yevhen",
    "job-title": "Senior Software Engineer"
  },
  "badges": {
    "title": "Badges"
  },
  "by-issuer": "by {{issuer}}",
  "certificates": {
    "title": "Certificates",
    "list": {
      "MWE43H8YDS": "Programming for everybody (Python)",
      "W5AB2PBZQNPY": "Parallel, Concurrent, and Distributed Programming in Java Specialization",
      "UC-JGDVYKAQ": "The Complete React Developer Course (w/ Hooks and Redux)",
      "689b9d7e-cae5-4e36-8a1f-c8c34f104249": "Oracle Certified Associate, Java SE 8 Programmer",
      "F75CDD8ED9F0": "Problem Solving (Basic)",
      "24722d5e-1738-4cec-808b-b4b83a94a8ad": "GitHub Advanced Security",
      "711c8e30-13e7-499e-aad6-5da9d468177a": "GitHub Actions",
      "6f36f952-612a-4aa1-8a3d-adb29396c967": "GitHub Foundations",
      "a1c1ec77-29db-4139-8fcb-ac95408653e8": "GitHub Administration",
      "9f12275d-a5b5-4d4d-9127-c975c555f0ab": "Certified DevSecOps Professional (CDP)",
      "55ddd8bd-950d-45bb-ad25-d08269bc9ca1": "GitHub Copilot",
      "517b6607-def7-46e1-b007-493a15b5eeb2": "Terraform Associate (003)"
    }
  },
  "comma": ", ",
  "contacts": {
    "title": "Contacts",
    "location": "Tokyo, Japan"
  },
  "education": {
    "title": "Education",
    "university": {
      "osar": {
        "speciality": "Information Technology. Master.",
        "title": "Odesa State Academy of Refrigeration"
      }
    }
  },
  "experience": {
    "present": "Present",
    "title": "Experience",
    "tech-stack": "Tech stack",
    "achievements": "Achievements",
    "body": {
      "woven-by-toyota": [
        "Created 3 main Application Security GitHub Actions for performing code scanning, SCA and SBOM analysis. They are used widely within the whole company. Currently, there are 1000+ invocations of those GitHub Actions per day.",
        "Designed authorization/authentication system that is used as a core system within the entire department (11 teams).",
        "Built a team of 6 engineers. It includes reviewing candidates, hiring process, mentoring and helping with personal growth.",
        "As a Security Champion in a team I've configured Application Security best practices on 50+ repositories (frontend, backend, IaC, etc.).",
        "Configured Keycloak as authorization/authentication system for the backend.",
        "Leading backend project in Go from E2E."
      ],
      "bitcoin-com": [
        "Increased unit tests code coverage on a Java backend project from 0% to 80%.",
        "Restored legacy Android application. Upgraded it to the latest version, redesigned, added additional features and published a new release.",
        "Configured Travis CI for the backend application from scratch.",
        "Configured Bitrise for legacy Android application from scratch.",
        "Configured GitHub Actions for the web application from scratch."
      ],
      "lohika": "Lohika is an outsourcing company, where I was working as an off-shore contractor for various companies but mostly for Hewlett Packard Enterprise. I developed RIA, backend, mobile and various web applications.",
      "arka": "Developing investing application as an internal project. Also, developing various web applications for external customers mostly from Germany."
    }
  },
  "header": {
    "occupation": "Senior Software Engineer",
    "title": "Hello, I'm {{authorGivenName}}"
  },
  "languages": {
    "title": "Languages",
    "fluent": "Fluent",
    "native": "Native",
    "codes": {
      "gb": "English",
      "jp": "Japanese",
      "ru": "Russian",
      "ua": "Ukrainian"
    }
  },
  "locations": {
    "odesa": "Odesa, Ukraine",
    "chuo": "Chuo, Tokyo, Japan",
    "shibuya": "Shibuya, Tokyo, Japan"
  },
  "month": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  "resume": {
    "title": "Resume",
    "body": "To download my resume please go to my <1>LinkedIn page</1> and choose Resources → Save to PDF"
  },
  "skills": {
    "title": "Skills"
  },
  "stats": {
    "title": "Stats"
  },
  "themes": {
    "light": "Light",
    "dark": "Dark"
  },
  "title": "{{authorFullName}} :: {{authorJobTitle}}",
  "version": "Version {{version}}",
  "year": "year"
}
